module.exports = __webpack_public_path__ + "static/media/019.e7d4a3b5.jpg";